var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvDrawingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 2.5H20V5H17.5V7.5H15V10H12.5V12.5H10V15H7.5V17.5H5V20H2.5V27.5H10V25H12.5V22.5H15V20H17.5V17.5H20V15H22.5V12.5H25V10H27.5V7.5H25V5H22.5V2.5ZM20 7.5V10H22.5V12.5H20V15H17.5V17.5H15V20H12.5V22.5H10V20H7.5V17.5H10V15H12.5V12.5H15V10H17.5V7.5H20ZM7.5 20V22.5H10V25H5V20H7.5Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvDrawingIcon);
export default __webpack_public_path__ + "static/media/cv_drawing_icon.12ae3470d471d7beba34ca1a3b212933.svg";
export { ForwardRef as ReactComponent };